import {Component, inject, OnInit} from '@angular/core';
import {MarkdownComponent} from "ngx-markdown";
import {MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle} from "@angular/material/expansion";
import {ErrorHandlingService} from "../../../../services/error-handling.service";
import {IFrequentlyAskedQuestions} from "../../../../interfaces/IFrequentlyAskedQuestions";
import {UIStateEnum} from "../../../../enum/UIStateEnum";
import {FrequentlyAskedQuestionsService} from "../../../../services/frequently-asked-questions.service";
import {MatProgressSpinner} from "@angular/material/progress-spinner";
import {GameService} from "../../../../services/game.service";
import {IGameQueryResult} from "../../../../interfaces/IGameQueryResult";

@Component({
  selector: 'app-game-admin-view-faqs',
  standalone: true,
  imports: [
    MarkdownComponent,
    MatAccordion,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    MatProgressSpinner
  ],
  templateUrl: './game-admin-view-faqs.component.html',
  styleUrl: './game-admin-view-faqs.component.css'
})
export class GameAdminViewFaqsComponent implements OnInit {

  private errorHandlingService: ErrorHandlingService = inject(ErrorHandlingService);
  private frequentlyAskedQuestionsService: FrequentlyAskedQuestionsService = inject(FrequentlyAskedQuestionsService);
  private gameService: GameService = inject(GameService);

  public uiStateEnum = UIStateEnum;
  protected uiState: UIStateEnum = UIStateEnum.ShowLoading;

  public faqs: IFrequentlyAskedQuestions[] = [];
  public chosenGame: IGameQueryResult | null = null;

  ngOnInit(): void {
    this.chosenGame = this.gameService.activeGame();
    if (this.chosenGame?.Id) {
      this.loadFaqsForGame(this.chosenGame.Id);
    }
  }

  private loadFaqsForGame(gameId: string) {
    this.uiState = UIStateEnum.ShowLoading;
    this.frequentlyAskedQuestionsService.fetchAdminAppFaqs(gameId).subscribe({
      next: (res) => {
        this.faqs = res;
        this.uiState = UIStateEnum.ShowData;
      },
      error: (err) => {
        this.errorHandlingService.displayPageLevelErrorMessage(err);
        this.uiState = UIStateEnum.ShowData;
      },
    });
  }
}
